export default __webpack_public_path__ + "static/media/sections.15acb5d3.svg";